import PrayerGuide from './PrayerGuide';

export interface WrittenWork {
  id: string;
  title: string;
  subtitle: string;
  author: string;
  church: string;
  description: string;
  component: React.ComponentType;
}

export const writtenWorks: WrittenWork[] = [
  {
    id: 'prayer-guide',
    title: 'Sermons on the Lord\'s Prayer',
    subtitle: 'A Guide to Effective Praying',
    author: 'DAROLD H. MORGAN',
    church: 'FIRST BAPTIST CHURCH, Sherman, Texas',
    description: 'A series of sermons on The Lord\'s Prayer, preached in July and August, 1959. This volume contains insights on effective praying and spiritual guidance.',
    component: PrayerGuide,
  },
  // Add more written works here in the future
  // {
  //   id: 'another-work',
  //   title: 'Title',
  //   subtitle: 'Subtitle',
  //   author: 'Author',
  //   church: 'Church',
  //   description: 'Description',
  //   component: AnotherComponent,
  // },
];
